import React from 'react'

const GeotechnicalInvestigation = () => {
  return (
    <>
      <section className="services-details pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="section-title" />
            </div>
            <div className="col-lg-6">
              <div className="section-title" />
            </div>
            {/*Start Services Details Content*/}
            <div className="col-xl-12 col-lg-12">
              <div className="services-details__content">
                <h3>Geotechnical Investigation </h3>
                <p className="mb-30">
                  Geotechnical Investigation is a critical engineering process
                  required to evaluate subsurface soil and rock conditions prior
                  to the design and construction of any structure. The need for
                  this service arises from the complex and variable nature of
                  soil behavior underload, environmental conditions, and
                  long-term serviceability requirements.
                </p>
                <p className="mb-30">
                  Conducting a geotechnical investigation at the early stage of
                  a project is essential to achieving safe, durable, and
                  cost-effective engineering solutions.
                </p>
                <div className="content mt-40">
                  <div className="text">
                    <h3 className="mb-4">Purpose</h3>
                    <ul className="project-list">
                      <li className="d-flex align-items-center">
                        <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                        Identify subsurface conditions and soil stratification.
                      </li>

                      <li className="d-flex align-items-center">
                        <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                        Assess engineering properties of soil and rock.
                      </li>

                      <li className="d-flex align-items-center">
                        <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                        Evaluate geotechnical hazards and constraints.
                      </li>

                      <li className="d-flex align-items-center">
                        <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                        Support compliance with regulatory and contractual
                        requirements.
                      </li>

                      <li className="d-flex align-items-center">
                        <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                        Improve foundation systems and construction methods.
                      </li>
                    </ul>
                    <p className="mb-30">
                      From a commercial perspective, early geotechnical
                      assessment significantly reduces project uncertainty,
                      construction risks, delays, and unforeseen costs.
                    </p>
                  </div>
                </div>
                <div className="service-nr-list">
                  <h3 className="mb-5">Role of PAIC </h3>
                  <p className="mb-30">
                    Pak Arab Inspectin Limited Company delivers professional and independent Geotechnical
                    Investigation services following internationally recognized
                    standards and engineering best practices. Our services are
                    tailored to meet project-specific requirements for civil,
                    structural, industrial, and infrastructure developments.
                  </p>
                  <p className="mb-30">
                    Our team combines field ability, laboratory testing, and
                    engineering interpretation to provide right and actionable
                    geotechnical solutions that support informed
                    decision-making.
                  </p>
                </div>
                <div className="service-nr-list">
                  <h3 className="">Scope </h3>
                  <h4 className="">
                    Our services included, but are not limited to:{" "}
                  </h4>
                  <div className="row">
                    <div className="col-lg-4">
                       <h5>Field Testing</h5>
                      <ul className="outcome-list">
                        <li>
                          <i className="fal fa-check" /> Piezocone Penetration
                          Testing & Cone Penetration Test (CPTu and CPT).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Pressure-meter Test
                          (Ménard Pressure-meter).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Field CBR and Plate
                          Bearing Tests.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Pile Load Testing.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Anchoring Systems
                          Pull-out Test.
                        </li>

                        <li>
                          <i className="fal fa-check" /> In-Situ Soil
                          Permeability Tests (LeFranc Test) and Rock
                          Permeability Tests (Packer Test).
                        </li>
                        <li>
                          <i className="fal fa-check" /> Field Density Test
                          (FDT).
                        </li>
                        <li>
                          <i className="fal fa-check" /> Groundwater Survey.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-4">
                      <ul className="outcome-list mb-5">
                        <li>
                          <i className="fal fa-check" /> Dynamic Cone
                          Penetration Test (DCPT).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Trial Pits Test.
                        </li>

                        <li>
                          <i className="fal fa-check" /> TV Logging & Borehole
                          Televiewer Logging.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Percolation Test.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Soil Thermal
                          Resistivity Testing.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Pull-Out Testing of
                          Driven Steel Piles (Solar Power Panels):
                          <ul className="outcome-list mt-2 my-list">
                            <li>Vertical Compression Test</li>

                            <li>Horizontal Extraction (Lateral Shear Test).</li>

                            <li>Vertical Extraction Test (Pull-out Test).</li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-4">
                        <h5>Surface Geophysical Exploration</h5>
                      <ul className="outcome-list mb-5">
                        <li>
                          <i className="fal fa-check" /> Piezocone Penetration
                          Testing & Cone Penetration Test (CPTu and CPT).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Electrical Resistivity
                          Methods.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Electrical Resistivity
                          Tomography (2D & 3D).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Vertical Electrical
                          Sounding.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Surface Seismic
                          Methods.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Multi-Channel Analysis
                          of Surface Waves (MASW).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Seismic Refraction
                          Tomography.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Vibration Monitoring.
                        </li>

                        <li>
                          <i className="fal fa-check" /> Ground Penetration
                          Radar (GPR).
                        </li>

                        <li>
                          <i className="fal fa-check" /> Micro-Gravity (MG).
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div>
                    <h5>Borehole Geophysical Investigation</h5>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="nr-list mb-5">
                          <h4 className="title d-flex align-items-center mb-4">
                            <span>01</span> Borehole Seismic Survey
                          </h4>
                          <ul className="outcome-list mt-2">
                            <li>
                              <i className="fal fa-check" /> Cross Hole Seismic
                            </li>

                            <li>
                              <i className="fal fa-check" /> Down Hole Seismic
                            </li>

                            <li>
                              <i className="fal fa-check" /> P-S Suspension
                              Logging
                            </li>

                            <li>
                              <i className="fal fa-check" /> Seismic Cone
                              Penetration Test (SCPT)
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="nr-list mb-5">
                          <h4 className="title d-flex align-items-center mb-4">
                            <span>02</span> Borehole Geophysical Logging
                          </h4>
                          <ul className="outcome-list mt-2">
                            <li>
                              <i className="fal fa-check" /> Fluid Temperature &
                              Conductivity
                            </li>

                            <li>
                              <i className="fal fa-check" /> Gamma-Gamma
                            </li>

                            <li>
                              <i className="fal fa-check" /> Natural Gamma
                            </li>

                            <li>
                              <i className="fal fa-check" /> Electrical
                              Resistivity
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="nr-list mb-5">
                          <ul className="outcome-list mt-2">
                            <li>
                              <i className="fal fa-check" /> Deviation
                              (Verticality)
                            </li>

                            <li>
                              <i className="fal fa-check" /> TV Logging &
                              Borehole Televiewer Logging
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <h5>Geotechnical Consultancy</h5>
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="nr-list mb-5">
                          <h4 className="title d-flex align-items-center mb-4">
                            <span>01</span> Slope Stability – Embankment
                            Stability
                          </h4>
                          <ul className="outcome-list mt-2">
                            <li>
                              <i className="fal fa-check" /> Slope Stability
                              Analysis
                            </li>

                            <li>
                              <i className="fal fa-check" /> Design of Road and
                              Railway Embankments
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="nr-list mb-5">
                          <h4 className="title d-flex align-items-center mb-4">
                            <span>02</span> Deep Excavation support systems
                          </h4>
                          <ul className="outcome-list mt-2">
                            <li>
                              <i className="fal fa-check" /> Shotcrete Slope
                              Stabilization
                            </li>

                            <li>
                              <i className="fal fa-check" /> Reinforced Earth
                              Fills
                            </li>

                            <li>
                              <i className="fal fa-check" /> Compaction Grouting
                            </li>

                            <li>
                              <i className="fal fa-check" /> Soil / Geogrid
                              Reinforcement
                            </li>

                            <li>
                              <i className="fal fa-check" /> Stone Column
                            </li>

                            <li>
                              <i className="fal fa-check" /> Rock Fill
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="nr-list mb-5">
                          <h4 className="title d-flex align-items-center mb-4">
                            <span>03</span>Soil Stabilization & Soil Improvement
                          </h4>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="nr-list mb-5">
                          <h4 className="title d-flex align-items-center mb-4">
                            <span>04</span>Sand Dunes impact and sand mitigation
                            assessment.
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default GeotechnicalInvestigation;